import React from 'react';

export default function LinksIcon({ width = 28, height = 28, fill = '#FE5442', ...props }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6.60876 10.6181C6.90252 10.9102 6.90396 11.385 6.61194 11.6788L4.93036 13.3703C4.55746 13.7432 4.25392 14.1912 4.053 14.6768C3.85167 15.1633 3.75 15.6856 3.75 16.22C3.75 16.7543 3.85168 17.2767 4.053 17.7632C4.25392 18.2488 4.55745 18.6967 4.93036 19.0696L4.93631 19.0756C5.30165 19.4492 5.74538 19.7437 6.23676 19.947C6.72258 20.1481 7.25484 20.25 7.78002 20.25C8.30358 20.25 8.82594 20.1486 9.3132 19.947C9.79782 19.7465 10.245 19.4438 10.6174 19.0719L12.2749 17.3844C12.5652 17.0889 13.04 17.0846 13.3355 17.3749C13.631 17.6651 13.6353 18.14 13.3451 18.4355L11.6804 20.1303C11.1733 20.6374 10.5611 21.0539 9.88674 21.333C9.21402 21.6114 8.49648 21.75 7.78002 21.75C7.06524 21.75 6.33744 21.612 5.66325 21.333C4.99592 21.0569 4.3808 20.6522 3.86673 20.1274C3.36097 19.6208 2.94551 19.0099 2.66697 18.3368C2.3883 17.6633 2.25 16.9456 2.25 16.22C2.25 15.4943 2.3883 14.7767 2.66697 14.1032C2.9459 13.4292 3.36214 12.8174 3.86886 12.3105L3.86969 12.3097L5.54812 10.6213C5.84014 10.3275 6.315 10.3261 6.60876 10.6181Z"
        fill={fill}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M13.3692 4.93189L11.6808 6.62034C11.3878 6.91326 10.9129 6.91326 10.6201 6.62034C10.3272 6.32748 10.3272 5.85259 10.6201 5.5597L12.313 3.86673C13.35 2.84128 14.7481 2.25 16.2204 2.25C17.689 2.25 19.0899 2.82887 20.1307 3.86969L20.1336 3.87266C21.1591 4.90964 21.7504 6.3078 21.7504 7.78002C21.7504 9.25224 21.1591 10.6504 20.1336 11.6873L20.1307 11.6903L18.4407 13.3803C18.1478 13.6732 17.6729 13.6732 17.38 13.3803C17.0871 13.0874 17.0871 12.6125 17.38 12.3196L19.0671 10.6326L19.0685 10.6312C19.8222 9.86832 20.2504 8.84712 20.2504 7.78002C20.2504 6.71292 19.8222 5.69173 19.0686 4.92887C18.3095 4.17062 17.291 3.75 16.2204 3.75C15.1533 3.75 14.1321 4.17822 13.3692 4.93189Z"
        fill={fill}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M15.8708 8.10006C16.1635 8.39316 16.1632 8.86806 15.87 9.16074L9.11004 15.9107C8.81688 16.2034 8.34204 16.2031 8.04936 15.91C7.75668 15.6169 7.75704 15.142 8.05014 14.8493L14.8102 8.09928C15.1033 7.8066 15.5782 7.80696 15.8708 8.10006Z"
        fill={fill}
      />
    </svg>
  );
}
